module.exports = __webpack_public_path__ + "img/doubledash.03a49f7f.svg";